import { useEffect, useState } from "react";
import { X, ChevronDown, Video } from 'lucide-react';

const ViewPtSessionModal = ({ data, onClose, onOpenViewer }) => {
  console.log("data", data)
  const [sessionName, setSessionName] = useState(data?.title || '');
  const [sessionDescription, setSessionDescription] = useState(data?.description || '');
  const [exercises, setExercises] = useState([]);

  useEffect(() => {
    if (data?.activities?.length > 0) {
      const initialized = data.activities.map((ex) => ({
        ...ex,
        name: ex.display_name || ex.name || '',
        reps: ex.reps || 8,
        hold: ex.hold_in_seconds || 0,
        set_limb_instruction: ex.set_limb_instruction || null,
        limb_instructions: ex.limb_instructions || [],
        videoUrl: ex.video || '',
        limb: ex.limb || 'N',
      }));
      setExercises(initialized);
    } else if (data?.exercises?.length > 0) {
      const initialized = data.exercises.map((ex) => ({
        ...ex,
        name: ex.display_name || ex.name || '',
        reps: ex.reps || 8,
        hold: ex.hold_in_seconds || 0,
        set_limb_instruction: ex.set_limb_instruction || null,
        limb_instructions: ex.limb_instructions || [],
        videoUrl: ex.video || '',
        limb: ex.limb || 'N',
      }));
      setExercises(initialized);
    }
  }, [data]);


  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[60] animate-fade-in-up">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-[95vw] sm:max-w-5xl p-6 transform transition-all flex flex-col max-h-[90vh]">

        {/* Header */}
        <div className="flex justify-between items-center mb-4 border-b pb-4">
          <h2 className="text-2xl font-bold text-gray-800">{sessionName}</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-200 transition">
            <X size={24} />
          </button>
        </div>

        {/* Session Info */}
        <div className="grid grid-cols-1 gap-4 mb-6">
          <div>
            <label className="text-sm text-gray-500">Description</label>
            <div className="font-medium text-gray-800">{sessionDescription || "N/A"}</div>
          </div>

        </div>

        {/* Exercise List */}
        <div className="flex-grow overflow-y-auto pr-2">
          {exercises.length === 0 ? (
            <div className="text-center text-gray-500 py-10">No exercises found.</div>
          ) : (
            <div className="flex flex-col gap-2">
              {exercises?.filter(
                (ex, index, self) =>
                  index === self.findIndex((e) => e.set_id === ex.set_id)
              )?.map((ex, idx) => (
                <div key={idx} className="flex items-center gap-4 p-3 border rounded-lg bg-gray-50">
                  <div className="flex-1 font-semibold text-gray-800 min-w-[150px]">{ex.name}</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2 items-start text-sm flex-1">

                    {/* STATUS */}
                    <div>
                      <span className="block text-gray-500 mb-1">Status:</span>
                      <div className="text-gray-800">
                        {
                          ex.is_complete
                            ? 'Completed'
                            : ex.is_skipped
                              ? 'Skipped'
                              : 'Pending'
                        }
                      </div>
                    </div>

                    {/* Max ROM */}
                    <div>
                      <span className="block text-gray-500 mb-1">Max ROM:</span>
                      <div className="text-gray-800">
                        {ex?.have_rom === 1 ? ex?.target_rom_max : "N/A"}
                      </div>
                    </div>

                    {/* Sets */}
                    <div>
                      <span className="block text-gray-500 mb-1">Sets:</span>
                      <div className="text-gray-800">
                        {exercises.filter(e => e.set_id === ex.set_id).length}
                      </div>
                    </div>

                    {/* Reps */}
                    <div>
                      <span className="block text-gray-500 mb-1">Reps:</span>
                      <div className="text-gray-800">{ex.reps}</div>
                    </div>

                    {/* Hold */}
                    <div>
                      <span className="block text-gray-500 mb-1">Hold (s):</span>
                      <div className="text-gray-800">{ex?.exercise_data?.hold_in_seconds || ex?.hold_in_seconds || 0}</div>
                    </div>

                    {/* Limb */}
                    <div>
                      <span className="block text-gray-500 mb-1">Limb:</span>
                      <div className="text-gray-800">{ex?.set_limb_instruction?.name || "N/A"}</div>
                    </div>
                  </div>

                  {/* Watch Button */}
                  {/* {ex.videoUrl && (
                    <div className="ml-4">
                      <button
                        onClick={() => onOpenViewer({ ...ex, title: ex.name, content: ex.videoUrl, category: 'Video' })}
                        className="text-[#166273] hover:text-[#166273]/90 transition"
                      >
                        <Video size={20} />
                      </button>
                    </div>
                  )} */}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewPtSessionModal;
